export function createGeofenceClient(transport) {
    return {
        /**
         * The geofences a tenant has drawn
         *
         * Requires scope: geo:geofence:read
         */
        getTenantsGeofences(tenantId, status, limit, after, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/geofences`,
                query: { status: status, limit: limit, after: after },
                options,
            });
        },
        /**
         * Create a geofence
         *
         * Requires scope: geo:geofence:write
         */
        postTenantsGeofences(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/geofences`,
                body,
                options,
            });
        },
        /**
         * Read a geofence, including the version an amendment must carry
         *
         * Requires scope: geo:geofence:read
         */
        getTenantsGeofences2(tenantId, geofenceId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/geofences/${encodeURIComponent(geofenceId)}`,
                options,
            });
        },
        /**
         * Replace a geofence using optimistic concurrency
         *
         * Requires scope: geo:geofence:write
         */
        putTenantsGeofences(tenantId, geofenceId, body, options) {
            return transport.request({
                method: "PUT",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/geofences/${encodeURIComponent(geofenceId)}`,
                body,
                options,
            });
        },
        /**
         * Deterministically evaluate point membership
         *
         * Requires scope: geo:geofence:evaluate
         */
        postTenantsGeofencesEvaluations(tenantId, geofenceId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/geofences/${encodeURIComponent(geofenceId)}/evaluations`,
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=geofence.js.map